<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert, useTrack } from 'dashboard/composables';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { CONVERSATION_EVENTS } from '../../../../helper/AnalyticsHelper/events';

import NextButton from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const props = defineProps({
  conversationId: {
    type: [Number, String],
    required: true,
  },
});

const store = useStore();
const { t } = useI18n();

const showMenu = ref(false);

const macros = useMapGetter('macros/getMacros');
const uiFlags = useMapGetter('macros/getUIFlags');

const menuItems = computed(() =>
  macros.value.map(macro => ({
    label: macro.name,
    value: macro.id,
    action: 'execute',
  }))
);

const toggleMenu = () => {
  showMenu.value = !showMenu.value;
  if (showMenu.value && !macros.value.length) {
    store.dispatch('macros/get');
  }
};

const closeMenu = () => {
  showMenu.value = false;
};

const handleAction = async ({ action, value }) => {
  if (action !== 'execute') return;
  try {
    await store.dispatch('macros/execute', {
      macroId: value,
      conversationIds: [props.conversationId],
    });
    useTrack(CONVERSATION_EVENTS.EXECUTED_A_MACRO);
    useAlert(t('MACROS.EXECUTE.EXECUTED_SUCCESSFULLY'));
  } catch (error) {
    useAlert(t('MACROS.ERROR'));
  } finally {
    closeMenu();
  }
};
</script>

<template>
  <div v-on-clickaway="closeMenu" class="relative inline-flex">
    <NextButton
      v-tooltip.top-end="t('CONVERSATION.FOOTER.RUN_MACRO_TOOLTIP')"
      icon="i-ph-lightning"
      slate
      faded
      sm
      :class="showMenu ? 'bg-n-alpha-2' : ''"
      @click="toggleMenu"
    />
    <DropdownMenu
      v-if="showMenu"
      show-search
      :menu-items="menuItems"
      :is-loading="uiFlags.isFetching"
      class="bottom-full mb-2 left-0 w-64"
      @action="handleAction"
    />
  </div>
</template>
